import CircleInfo from "@dana/Icons/CircleInfo";
import { themeColors } from "@dana/MobiusOverrides/styles/colors";
import { fontWeights } from "@dana/MobiusOverrides/styles/typography";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import { IconMemo } from "@insite/mobius/Icon";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Modal from "@insite/mobius/Modal";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    salesRepDetails: string;
    message?: string;
    extendedStyles?: SalesRepModelStyles;
}

type Props = OwnProps;

export interface SalesRepModelStyles {
    wrapper?: InjectableCss;
    messageStyles?: InjectableCss;
    salesRepDetails?: InjectableCss;
    salesRepName?: TypographyPresentationProps;
    salesRepEmail?: LinkPresentationProps;
    salesRepContact?: LinkPresentationProps;
}

export const salesRepModelStyles: SalesRepModelStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 8px;
            cursor: pointer;
        `,
    },
    salesRepDetails: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: center;
        `,
    },
    salesRepName: {
        weight: fontWeights.semiBold,
        css: css`
            margin-bottom: 4px;
        `,
    },
    salesRepEmail: {
        css: css`
            margin-bottom: 4px;
        `,
    },
    salesRepContact: {
        css: css`
            margin-bottom: 4px;
        `,
    },
};

const ProductDetailsSalesRepModel = ({ salesRepDetails, extendedStyles, message }: Props) => {
    const [styles] = useState(() => mergeToNew(salesRepModelStyles, extendedStyles));
    let salesDetails;
    if (salesRepDetails !== "") {
        try {
            salesDetails = JSON.parse(salesRepDetails);
        } catch (e) {
            salesDetails = "";
        }
    }
    const [openSalesRepModalIsOpen, setopenSalesRepModalIsOpen] = useState(false);

    const openSalesRepModalCloseHandler = () => {
        setopenSalesRepModalIsOpen(false);
    };
    const findSalesRepClickHandler = () => {
        setopenSalesRepModalIsOpen(true);
    };
    console.log("message =->",message)
    return (
        <div>
            <StyledWrapper {...styles.messageStyles}>
                <Typography as="p" className="info-message-box">
                    <IconMemo size={13} src={CircleInfo} />{" "}
                    {message !== undefined &&     message !== "" ? message : siteMessage("ProductDetailPage_NotAvailableAddToCart_Message")}{" "}
                    <Link onClick={findSalesRepClickHandler}>{translate("Find My Rep")}</Link>
                </Typography>
            </StyledWrapper>
            <Modal
                headline={translate("My Sales Representive")}
                isOpen={openSalesRepModalIsOpen}
                handleClose={openSalesRepModalCloseHandler}
            >
                <StyledWrapper {...styles.wrapper}>
                    {salesDetails ? (
                        <StyledWrapper {...styles.salesRepDetails}>
                            <Typography {...styles.salesRepName}>{salesDetails?.name}</Typography>
                            <Link href={`mailto:${salesDetails?.email}`} {...styles.salesRepEmail}>
                                {salesDetails?.email}
                            </Link>
                            <Link href={`tel:${salesDetails?.phone}`} {...styles.salesRepContact}>
                                {salesDetails?.phone}
                            </Link>
                        </StyledWrapper>
                    ) : (
                        <div>
                            <Typography>{siteMessage("ProductDetailPage_SalesRepNotAssigned_Message")}</Typography>
                        </div>
                    )}
                </StyledWrapper>
            </Modal>
        </div>
    );
};

export default ProductDetailsSalesRepModel;
